import React from "react";
import { VisitorTypeHost } from "@gettactic/api";
import { UserLabel } from "@cmp-src/labels/UserLabel/UserLabel";

export interface HostLabelProps {
  host: VisitorTypeHost;
  /** Not used. */
  isSelected?: boolean;
  /** Not used. */
  onClick?: () => void;
  className?: string;
}

const mapHostToUser = (host: VisitorTypeHost) => ({
  id: host.id,
  name: host.name,
  email: host.email,
  profile_photo_url: host.profile_photo_url ?? null,
  title: host.title || ""
});

/** The host of a visit: a `UserLabel` in its host variant. */
export const HostLabel: React.FC<HostLabelProps> = ({ host, className }) => {
  const user = mapHostToUser(host);

  return (
    <UserLabel
      user={user}
      variant="host"
      className={className}
      showTitle
      showEmail={false}
      allowTruncate
    />
  );
};
